import { IChevronRightProps } from "interfaces";

const ChevronRightIcon = ({ className, onClick }: IChevronRightProps) => {
    return (
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M6.74906 2.49736C6.89156 2.49736 7.03406 2.54986 7.14656 2.66236L12.0366 7.55236C12.8316 8.34736 12.8316 9.65236 12.0366 10.4474L7.14656 15.3374C6.92906 15.5549 6.56906 15.5549 6.35156 15.3374C6.13406 15.1199 6.13406 14.7599 6.35156 14.5424L11.2416 9.65236C11.6016 9.29236 11.6016 8.70736 11.2416 8.34736L6.35156 3.45736C6.13406 3.23986 6.13406 2.87986 6.35156 2.66236C6.46406 2.55736 6.60656 2.49736 6.74906 2.49736Z" />
        </svg>
    );
};

export default ChevronRightIcon;
